import React, { useState, useEffect, useContext} from "react"
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/fr'
import {
  Box,
  Container,
  Button,
  Hidden,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import pixelButtonIcon from '../../images/pixelButtonIcon.svg';
import BusinessIcon from '@mui/icons-material/Business';
import AlarmIcon from '@mui/icons-material/Alarm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import {
  Box as BoxIcon,
} from 'react-feather';

import PageContentWrapper from "../PageContentWrapper"

import ScansContext from "../../contexts/ScansContext"

import { getCurrentUser } from "../../utils/auth"
import { theLab_url } from "../../utils/APIS"

moment.locale("fr");


const ScanWrapper = ({ scan, type }) => {
  // Point 3 : cote candidat on affiche l'entreprise cliente (users.poste du
  // recruteur), jamais le nom du recruteur. Les comptes recruteurs anterieurs
  // a mai 2026 n'ont pas d'entreprise en base : on masque la ligne plutot que
  // d'afficher un nom de personne a cote de l'icone d'immeuble.
  let companyName = scan?.ownerCompany
  return (
    <Box sx={{
      width:"100%",
      background:"white",
      border:type==="invited" ? "1px solid black" : "1px solid #E7E7E7",
      padding:["15px", "20px", "30px"],
      maxWidth:"100%",
      display:"flex",
      flexDirection:"column",
      gap:["10px", "15px", "15px"],
    }}>
      <Box sx={{
        display:"flex",
        justifyContent:"space-between",
        gap:["0px", "10px", "10px"],
        alignItems:"center",
        flexDirection:["column", "row", "row"],
      }}>
        <Box sx={{
          display:"flex",
          overflow:"hidden",
          gap:"3px",
          alignItems:"center",
          textAlign:"left",
          width:["100%", "unset", "unset"],
        }}>
          {companyName &&
            <>
              <BusinessIcon sx={{width:"18px", height:"18px"}}/>
              <Box sx={{
                fontWeight:400,
                color:"text.primary",
                fontSize:["14px", "15px", "16px"],
                overflow:"hidden",
                textOverflow:"ellipsis",
                whiteSpace:"nowrap",
              }}>
                {companyName}
              </Box>
            </>
          }
        </Box>
        {type === "invited" &&
          <Box sx={{
            fontWeight:400,
            color:"text.primary",
            fontSize:["13px", "15px", "16px"],
            overflow:"hidden",
            textOverflow:"ellipsis",
            whiteSpace:"nowrap",
            textAlign:"right",
            width:["100%", "unset", "unset"],
          }}>
            {moment(scan?.invitCreatedAt).calendar()}
          </Box>
        }
      </Box>
      {/* Maquette : le candidat voit le POSTE auquel il postule (nom du scan),
          pas le nom du module interne. */}
      <Box sx={{
        fontWeight:400,
        color:"text.black",
        fontSize:["20px", "24px", "32px"],
        lineHeight:"1.2",
        overflow:"hidden",
        textOverflow:"ellipsis",
        whiteSpace:"nowrap",
      }}>
        {scan?.name || scan?.module?.name}
      </Box>
      <Box sx={{
        fontWeight:400,
        color:"text.primary",
        fontSize:["15px", "16px", "18px"],
        lineHeight:"1.45",
        height:["60px", "68px", "78px"],
        overflow:"hidden",
        textOverflow:"ellipsis",
        lineClamp:3,
        display: "-webkit-box",
        WebkitLineClamp : 3,
        WebkitBoxOrient : "vertical",
      }}>
        {scan?.module?.description}
      </Box>
      <Box sx={{
        display:"flex",
        py:["3px", "5px", "8px"],
        gap:"10px",
        flexWrap:"wrap",
        alignItems:["flex-start", "center", "center"],
        flexDirection:["column", "row", "row"]
      }}>
        {type === "invited" &&
          <Button
            sx={{
              order : [2, 1, 1],
            }}
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            endIcon={type === "invited" ? <img src={pixelButtonIcon} style={{width:"13px", height:"13px"}} alt=""/> : null}
            /* PD-10 (25/09/2026) : ce bouton sert seulement à commencer ou à
               continuer un scan. Un scan terminé n'en a pas : le candidat ne
               voit aucun résultat (DECISIONS-PRODUIT.md). */
            disabled={scan.isOpen === true ? false : true}
            onClick={() => {
              window.location.href = theLab_url+"/thescan/"+scan?.usersGroupesID;
            }}
          >
            {(type === "invited" && scan?.scanStatus === "notStarted") && "Commencer"}
            {(type === "invited" && scan?.scanStatus === "inProgress") && "Continuer"}
          </Button>
        }
        <Box sx={{
          order : [1, 2, 2],
          display:"flex",
          gap:"3px",
          alignItems:"center",
          color:"text.primary",
          maxWidth:"100%",
        }}>
          {(type === "invited" && scan?.scanStatus === "notStarted") && <AlarmIcon sx={{width:"18px", height:"18px"}}/>}
          {type === "completed" && <CheckCircleIcon sx={{width:"18px", height:"18px"}}/>}
          <Box sx={{
            fontWeight:400,
            color:"text.primary",
            fontSize:["14px", "16px", "16px"],
            overflow:"hidden",
            textOverflow:"ellipsis",
            whiteSpace:"nowrap",
            useSelect:"none",
            //textTransform:"capitalize",
            maxWidth:"100%",
          }}>
            {(type === "invited" && scan?.isOpen !== true) && `Fermé`}
            {(type === "invited" && scan?.scanStatus === "notStarted" && scan?.isOpen === true) && `${scan?.module?.timing} minutes`}
            {(type === "invited" && scan?.scanStatus === "inProgress" && scan?.isOpen === true) && `${scan?.userFormations?.progress}\u00a0% complété`}
            {/* PD-10 (25/09/2026) : le candidat ne voit aucun résultat (DECISIONS-PRODUIT.md). */}
            {type === "completed" && `Terminé le ${moment(scan?.userFormations?.resultUpdatedAt).format('DD/MM/YYYY')}, résultats transmis au recruteur.`}
          </Box>
        </Box>

      </Box>
    </Box>
  )
}


const CandidatScans = ({ }) => {
  const navigate = useNavigate();
  const { isLoaded, scans } = useContext(ScansContext)

  const getFirstName = () => {
    let completeName = getCurrentUser()?.name
    return completeName?.split(" ")[0]
  }

  const [invitedScans, setInvitedScans] = useState([])
  const [completedScans, setCompletedScans] = useState([])
  const [scansLoaded, setScansLoaded] = useState(false)

  useEffect(() => {
    if (isLoaded === true) {
      let invited = []
      let completed = []
      //on doit filtrer si complété ou pas
      scans.forEach((scan) => {
        if (scan?.scanStatus === "completed") {
          completed.push(scan)
        } else {
          invited.push(scan)
        }
      })
      setInvitedScans(invited)
      setCompletedScans(completed)
      setScansLoaded(true)
    }
  }, [isLoaded, scans])


  return (
    <>
      <PageContentWrapper
        title={"Bon retour, "+getFirstName()}   // maquette : « Welcome back, X »
      >
        <Box sx={{display:"flex", flexDirection:"column", gap:["15px", "20px", "30px"], width:"100%"}}>
          {(scansLoaded === true && invitedScans?.length > 0) &&
            <Box>
              <Box sx={{
                fontSize:["22px", "26px", "28px"],
                color:"text.black",
              }}>
                Vous avez été invité
              </Box>
              <Box sx={{
                display:"grid",
                gridTemplateColumns:["1fr", "1fr 1fr", "1fr 1fr", "1fr 1fr 1fr"],
                py:["10px", "15px", "20px"],
                gap:["15px", "20px", "24px"],
                alignItems:"stretch",
               }}>
                {invitedScans.map((scan, index) => {
                  return (
                    <ScanWrapper
                      key={index}
                      scan={scan}
                      type={"invited"}
                    />
                  )
                })}
              </Box>
            </Box>
          }
          {(scansLoaded === true && completedScans?.length > 0) &&
            <Box>
              <Box sx={{
                fontSize:["22px", "26px", "28px"],
                color:"text.black",
              }}>
                Scans complétés
              </Box>
              <Box sx={{
                display:"grid",
                gridTemplateColumns:["1fr", "1fr 1fr", "1fr 1fr", "1fr 1fr 1fr"],
                py:["10px", "15px", "20px"],
                gap:["15px", "20px", "24px"],
                alignItems:"stretch",
               }}>
               {completedScans.map((scan, index) => {
                 return (
                   <ScanWrapper
                     key={index}
                     scan={scan}
                     type={"completed"}
                   />
                 )
               })}
              </Box>
            </Box>
          }
        </Box>
        {(scansLoaded === true && invitedScans?.length === 0 && completedScans?.length === 0) &&
          <Box sx={{display:"flex",  flexDirection:"column", flex:1}}>
            <Box sx={{
              background:"white",
              border:"1px solid #E7E7E7",
              py : ["70px", "50px", "40px"],
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"20px"
            }}>
              <Box sx={{
                fontSize:["24px", "32px", "32px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Aucun Scan disponible</Box>
            </Box>
          </Box>
        }
      </PageContentWrapper>
    </>
  )
};

export default CandidatScans;
